import React, {ReactNode} from 'react';
import cx from 'classnames';
import {isRTL} from '../../../../Localization';
import styles from './style.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

type Props = {
    componentClasses?: string;
    text?: string;
    children?: ReactNode;
    onClick?: (event) => void;
    disabled?: boolean;
    testId?: string;
};

export const Tag = ({componentClasses, text, children, onClick, disabled, testId}: Props) => {
    return (
        <div
            className={cx(styles.wrapper, componentClasses, {
                [styles.disabled]: disabled
            })}
            onClick={!disabled ? onClick : undefined}
            dir={isRTL() ? 'rtl' : 'ltr'}
            {...createDataTestId(testId, false)}
        >
            {children}
            <p className={cx(styles.text, {[styles.isRTL]: isRTL()})}>{text}</p>
        </div>
    );
};
